<template>
  <div
    id="floatingButton"
    class="button-container"
  >
    <button
      class="floating-button"
      @click="setShowReport(true)"
    >
      <img
        :src="IMAGE_BASE_URL + `/character/feedback/${showReport ? 'active' :'normal'}.png`"
        alt="feedback"
      >
    </button>
  </div>

  <Teleport
    v-if="showReport"
    to="#floatingButton"
  >
    <FeedbackForm @close="setShowReport(false)" />
  </Teleport>
</template>

<script setup lang="ts">
import FeedbackForm from '~/components/@pages/home/FeedbackForm.vue'
import { IMAGE_BASE_URL } from '~/constants/image.constant'

const showReport = ref(false)

const setShowReport = (value: boolean) => {
  showReport.value = value
}
</script>

<style scoped lang="scss">
.button-container {
  @apply fixed bottom-0 right-0 z-[5999];
}

.floating-button {
  @apply flex items-center justify-center w-full h-full;
  content: "";
}
</style>